import i18n from 'config/i18n';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

const t = i18n.getFixedT(getLocale(), 'common');

export const schema = yup.object({
  clientBrDynId: yup.number().required(t('surchargeRelations.invalid_client')),
  employerBrDynId: yup
    .number()
    .required(t('surchargeRelations.invalid_employer')),
  surchargeId: yup
    .number()
    .required(t('surchargeRelations.invalid_surcharge'))
    .typeError(t('surchargeRelations.invalid_surcharge'))
});
